import React, { Component } from 'react';
import Chart from 'react-google-charts';
import { Settings} from '@material-ui/icons';
import {Typography} from '@material-ui/core';


export default class ThreeSixtyBlock extends Component {
    constructor(props) {
        super(props);
        this.state={
            ave_score : 0,
            num_assessments : 0,
            graph_data: [],
            ave_score_percent: 0,
        }
    }

    componentDidMount = () => {
    //   console.log('this.props.data_array :>> ', this.props.data_array);
      let graph_header = [''];
      let graph_data = ['Score out of 10'];
      let total = 0;
      for (var i=0; i<this.props.data_array.length; i++){
        if (!graph_data.includes(this.props.data_array[i].assessment_type)){
            graph_header.push(this.props.data_array[i].assessment_type);
        }
        graph_data.push(Number(this.props.data_array[i].score));
        total+=Number(this.props.data_array[i].score);
      }
      graph_header.push("Average");
      graph_data.push(total / this.props.data_array.length);
      this.setState({
          num_assessments: this.props.data_array.length,
          ave_score : total / this.props.data_array.length,
          graph_data : [graph_header,graph_data],
          ave_score_percent : Math.round((total / this.props.data_array.length * 1000))/100
      })
    };
    
    render() {return (
        <Chart
            // width={'100%'}
            height={'375px'}
            width={'475px'}
            chartType="Bar"
            loader={
                <Typography
                    style={{marginTop:25}}
                >
                    <Settings className='icn-spinner' /><br/>
                    Generating graph...
                </Typography>
            }
            style={{fontFamily:'roboto',fontSize:14}}

            data={this.state.graph_data}
            options={{
                // Material design options
                chart: {
                    title: this.props.title + '  (' + this.state.ave_score_percent + '%)',
                    // subtitle: this.state.num_assessments.toString() + ' assessment result(s)',
                },
            }}
        />
    )}
}
